"use strict";

var _core = require("@emotion/core");

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = exports.Td = exports.Tbody = exports.TrGroup = exports.Tr = exports.Thead = exports.Th = exports.renderDensityhighlight = exports.renderDensity = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_1 = require("@emotion/core");

var foundation_1 = require("../../theme/foundation");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

exports.renderDensity = function (density) {
  switch (density) {
    case 'low':
      return 1.5;

    case 'medium':
      return 1;

    case 'high':
      return 0.5;

    default:
      return 1.5;
  }
};

exports.renderDensityhighlight = function (density) {
  switch (density) {
    case 'low':
      return {
        height: 2.5,
        margin: -0.875
      };

    case 'medium':
      return {
        height: 1.875,
        margin: -0.5
      };

    case 'high':
      return {
        height: 1.25,
        margin: -0.25
      };

    default:
      return {
        height: 1.875,
        margin: -0.5
      };
  }
};

exports.Th = utils_2.forwardRef(function TheadCol(props, ref) {
  var sortable = props.sortable,
      sort = props.sort,
      dispatch = props.dispatch,
      index = props.index,
      lastTdChild = props.lastTdChild,
      firstTdChild = props.firstTdChild,
      density = props.density;
  var theadTh = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t {\n\t\t\tpadding-top: ", "em;\n\t\t\tpadding-bottom: ", "em;\n\t\t\tpadding-left: 2em;\n\t\t\tpadding-right: 2em;\n\t\t\ttext-align: left;\n\t\t\t", ";\n\t\t\t", ";\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tpadding-top: ", "em;\n\t\t\tpadding-bottom: ", "em;\n\t\t\tpadding-left: 2em;\n\t\t\tpadding-right: 2em;\n\t\t\ttext-align: left;\n\t\t\t", ";\n\t\t\t", ";\n\t\t}\n\t"])), exports.renderDensity(density), exports.renderDensity(density), lastTdChild && "border-top-right-radius: 0.5rem", firstTdChild && "border-top-left-radius: 0.5rem");
  var theadThContainer = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t {\n\t\t\tdisplay: flex;\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tdisplay: flex;\n\t\t}\n\t"])));
  var iconStyle = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t {\n\t\t\tcolor: ", ";\n\t\t\tmargin-left: 0.5em;\n\t\t\tcursor: pointer;\n\t\t\ttransition: all 0.1s ease-in-out;\n\n\t\t\t&:hover {\n\t\t\t\ttransform: scale(1.1);\n\t\t\t\ttransition: all 0.1s ease-in-out;\n\t\t\t}\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tcolor: ", ";\n\t\t\tmargin-left: 0.5em;\n\t\t\tcursor: pointer;\n\t\t\ttransition: all 0.1s ease-in-out;\n\n\t\t\t&:hover {\n\t\t\t\ttransform: scale(1.1);\n\t\t\t\ttransition: all 0.1s ease-in-out;\n\t\t\t}\n\t\t}\n\t"])), foundation_1.colors.primary.green);

  var switchSort = function switchSort() {
    if (!sort.sort) {
      dispatch({
        index: index,
        sort: 'asc'
      });
    } else if (sort.sort === 'asc') {
      dispatch({
        index: index,
        sort: 'desc'
      });
    } else {
      dispatch({
        index: index,
        sort: 'asc'
      });
    }
  };

  return (0, _core.jsx)(lseds_1.lseds.th, {
    css: theadTh
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: theadThContainer
  }, (0, _core.jsx)(lseds_1.lseds.div, null, props.children), sortable && (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    css: iconStyle,
    icon: sort ? index === sort.index ? sort.sort === '' ? 'sort' : sort.sort === 'asc' ? 'sort-up' : 'sort-down' : 'sort' : 'sort',
    onClick: function onClick() {
      return switchSort();
    }
  })));
});
exports.Thead = utils_2.forwardRef(function Thead(props, ref) {
  var sortable = props.sortable,
      sort = props.sort,
      dispatch = props.dispatch,
      density = props.density,
      index = props.index;
  var thead = core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\t {\n\t\t\tbackground: ", ";\n\t\t\tcolor: ", ";\n\t\t\tfont-size: 0.813em;\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tbackground: ", ";\n\t\t\tcolor: ", ";\n\t\t\tfont-size: 0.813em;\n\t\t}\n\t"])), foundation_1.colors.graphical.bgLightGrey, foundation_1.colors.secondary.darkGrey);
  return (0, _core.jsx)(lseds_1.lseds.thead, {
    css: thead
  }, React.Children.map(props.children, function (child) {
    return React.cloneElement(child, {
      isHead: true,
      sortable: sortable,
      sort: sort,
      dispatch: dispatch,
      index: index,
      isThead: true,
      lastTdChild: props.children.length === index + 1,
      firstTdChild: index === 0,
      density: density
    });
  }));
});
exports.Tr = utils_2.forwardRef(function Tr(props, ref) {
  var trigger = props.trigger,
      child = props.child,
      highlighted = props.highlighted,
      selected = props.selected,
      TrProps = props.TrProps,
      density = props.density,
      isHead = props.isHead,
      onRowClick = props.onRowClick,
      sortable = props.sortable,
      sort = props.sort,
      dispatch = props.dispatch,
      lastTdChild = props.lastTdChild,
      firstTdChild = props.firstTdChild,
      lastTr = props.lastTr,
      isThead = props.isThead,
      rest = __rest(props, ["trigger", "child", "highlighted", "selected", "TrProps", "density", "isHead", "onRowClick", "sortable", "sort", "dispatch", "lastTdChild", "firstTdChild", "lastTr", "isThead"]); // props.children.length === idx +1


  var tr = core_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t\t {\n\t\t\tcursor: ", ";\n\t\t\tbackground: ", ";\n\t\t\t&:hover {\n\t\t\t\tbackground: ", ";\n\t\t\t\tbox-shadow: 0 0.563em 1.25em -0.625em rgba(66, 85, 99, 0.25);\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 0.31em;\n\t\t\t\theight: 1.25em;\n\t\t\t\tbackground: ", ";\n\t\t\t}\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tcursor: ", ";\n\t\t\tbackground: ", ";\n\t\t\t&:hover {\n\t\t\t\tbackground: ", ";\n\t\t\t\tbox-shadow: 0 0.563em 1.25em -0.625em rgba(66, 85, 99, 0.25);\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 0.31em;\n\t\t\t\theight: 1.25em;\n\t\t\t\tbackground: ", ";\n\t\t\t}\n\t\t}\n\t"])), trigger || onRowClick ? 'pointer' : 'inherit', isThead ? 'transparent' : selected ? foundation_1.colors.shades.bgLightGren : child || highlighted || isHead ? foundation_1.colors.graphical.bgLightGrey : foundation_1.colors.white, foundation_1.colors.graphical.bgLightGrey, foundation_1.colors.primary.green);
  return (0, _core.jsx)(lseds_1.lseds.tr, _extends({
    css: tr
  }, rest, {
    onClick: function onClick() {
      return onRowClick ? onRowClick() : null;
    }
  }), React.Children.map(props.children, function (child, index) {
    if (index === 0) {
      return React.cloneElement(child, __assign(__assign({}, core_1.css), {
        highlighted: highlighted,
        selected: selected,
        density: density,
        sortable: sortable,
        sort: sort,
        dispatch: dispatch,
        lastChild: props.children.length === index + 1,
        lastTdChild: props.children.length === index + 1,
        firstTdChild: isThead,
        lastTr: lastTr,
        index: index
      }));
    }

    return React.cloneElement(child, __assign(__assign({}, core_1.css), {
      density: density,
      sortable: sortable,
      sort: sort,
      dispatch: dispatch,
      lastTdChild: props.children.length === index + 1,
      firstTdChild: false,
      lastChild: isThead ? props.children.length === index + 1 : false,
      lastTr: lastTr,
      index: index
    }));
  }));
});
exports.TrGroup = utils_2.forwardRef(function TrGroup(props, ref) {
  var density = props.density;

  var _a = React.useState(false),
      visibleChild = _a[0],
      setVisibleChild = _a[1];

  var defaultStyle = "\n\t\tpadding-left: 2em;\n\t\tpadding-right: 2em;\n\t\ttext-align: left;\n\t\tfont-size: 0.813em;\t\t\n\t\tbackground: " + (visibleChild ? foundation_1.colors.graphical.bgLightGrey : 'inherit') + ";\n\t\t\n\t\t&:hover {\n\t\t\tbackground: " + (visibleChild ? foundation_1.colors.graphical.bgLightGrey : 'inherit') + "!important;\n\t\t}\n\t";
  var cssLow = core_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t\t {\n\t\t\tpadding-top: 1.5em;\n\t\t\tpadding-bottom: 1.5em;\n\t\t\tfont-weight: ", ";\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tpadding-top: 1.5em;\n\t\t\tpadding-bottom: 1.5em;\n\t\t\tfont-weight: ", ";\n\t\t\t", "\n\t\t}\n\t"])), visibleChild ? '800' : 'inherit', defaultStyle);
  var cssMedium = core_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t\t {\n\t\t\tpadding-top: 1em;\n\t\t\tpadding-bottom: 1em;\n\t\t\tfont-weight: ", ";\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tpadding-top: 1em;\n\t\t\tpadding-bottom: 1em;\n\t\t\tfont-weight: ", ";\n\t\t\t", "\n\t\t}\n\t"])), visibleChild ? '800' : 'inherit', defaultStyle);
  var cssHigh = core_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t\t {\n\t\t\tpadding-top: 0.5em;\n\t\t\tpadding-bottom: 0.5em;\n\t\t\tfont-weight: ", ";\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tpadding-top: 0.5em;\n\t\t\tpadding-bottom: 0.5em;\n\t\t\tfont-weight: ", ";\n\t\t\t", "\n\t\t}\n\t"])), visibleChild ? '800' : 'inherit', defaultStyle);
  var cssLowfirst = core_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\t\t {\n\t\t\tpadding-top: 1.5em;\n\t\t\tpadding-bottom: 1.5em;\n\t\t\tfont-weight: inherit;\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tpadding-top: 1.5em;\n\t\t\tpadding-bottom: 1.5em;\n\t\t\tfont-weight: inherit;\n\t\t\t", "\n\t\t}\n\t"])), defaultStyle);
  var cssMediumfirst = core_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\t\t {\n\t\t\tpadding-top: 1em;\n\t\t\tpadding-bottom: 1em;\n\t\t\tfont-weight: inherit;\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tpadding-top: 1em;\n\t\t\tpadding-bottom: 1em;\n\t\t\tfont-weight: inherit;\n\t\t\t", "\n\t\t}\n\t"])), defaultStyle);
  var cssHighfirst = core_1.css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\t\t {\n\t\t\tpadding-top: 0.5em;\n\t\t\tpadding-bottom: 0.5em;\n\t\t\tfont-weight: inherit;\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tpadding-top: 0.5em;\n\t\t\tpadding-bottom: 0.5em;\n\t\t\tfont-weight: inherit;\n\t\t\t", "\n\t\t}\n\t"])), defaultStyle);

  var setCssSpecs = function setCssSpecs(density, isChild) {
    switch (density) {
      case 'low':
        return isChild ? cssLow : cssLowfirst;

      case 'medium':
        return isChild ? cssMedium : cssMediumfirst;

      case 'high':
        return isChild ? cssHigh : cssHighfirst;

      default:
        return isChild ? cssLow : cssLowfirst;
    }
  };

  return (0, _core.jsx)(React.Fragment, null, React.Children.map(props.children, function (child, index) {
    // @ts-ignore
    return React.cloneElement( // @ts-ignore
    child, __assign(__assign({}, core_1.css), {
      density: density
    }), // @ts-ignore
    React.Children.map(child.props.children, function (child) {
      if (index === 0) {
        return React.cloneElement(child, {
          css: setCssSpecs(density, true),
          style: {
            boxShadow: visibleChild ? 'inset 0px 0.75em 0.5em; -0.5em rgba(0, 0, 0,  .1)' : 'none'
          },
          density: density,
          onClick: function onClick() {
            return setVisibleChild(!visibleChild);
          }
        });
      }

      if (index > 0 && visibleChild) {
        return React.cloneElement(child, {
          css: setCssSpecs(density),
          density: density
        });
      }
    }));
  }));
});
exports.Tbody = utils_2.forwardRef(function Tbody(props, ref) {
  var density = props.density,
      highlighted = props.highlighted,
      index = props.index,
      sortable = props.sortable,
      sort = props.sort,
      rest = __rest(props, ["density", "highlighted", "index", "sortable", "sort"]);

  var arrayToSort = [];

  if (sort.index !== -1) {
    React.Children.map(props.children, function (mainChild, index) {
      React.cloneElement(mainChild, __assign(__assign({}, core_1.css), {
        density: density
      }), React.Children.map(mainChild.props.children, function (child, idx) {
        if (idx === sort.index) {
          React.cloneElement(child, __assign(__assign({}, core_1.css), {
            density: density
          }), React.Children.map(child.props.children, function (child) {
            if (typeof child === 'string') {
              arrayToSort.push({
                index: index,
                content: child,
                mainChild: mainChild,
                props: __assign(__assign({}, core_1.css), {
                  density: density
                })
              });
            }
          }));
        }
      }));
    });
    React.Children.map(props.children, function (mainChild, index) {
      React.cloneElement(mainChild, __assign(__assign({}, core_1.css), {
        density: density
      }), React.Children.map(mainChild.props.children, function (child, idx) {
        if (idx === sort.index) {
          if (Array.isArray(child.props.children)) {
            arrayToSort.push({
              index: index,
              content: child,
              mainChild: mainChild,
              props: __assign(__assign({}, core_1.css), {
                density: density
              })
            });
          } else {
            React.cloneElement(child, __assign(__assign({}, core_1.css), {
              density: density
            }), React.Children.map(child.props.children, function (child) {
              if (typeof child !== 'string') {
                arrayToSort.push({
                  index: index,
                  content: child,
                  mainChild: mainChild,
                  props: __assign(__assign({}, core_1.css), {
                    density: density
                  })
                });
              }
            }));
          }
        }
      }));
    });
  }

  var sortArray = __spreadArrays(arrayToSort).sort(function (a, b) {
    if (typeof a.content === 'string' && typeof b.content === 'string') {
      if (a.content.toLowerCase() < b.content.toLowerCase()) {
        return sort.sort === 'asc' ? -1 : 1;
      }

      if (a.content.toLowerCase() > b.content.toLowerCase()) {
        return sort.sort === 'desc' ? -1 : 1;
      }
    }
  });

  return (0, _core.jsx)(lseds_1.lseds.tbody, null, sort.index === -1 ? React.Children.map(props.children, function (child, index) {
    return React.cloneElement(child, {
      sortable: sortable,
      sort: sort,
      index: index,
      density: density,
      lastTr: props.children.length === index + 1
    });
  }) : sortArray.map(function (data, index) {
    return React.cloneElement(data.mainChild, __assign(__assign({}, data.props), {
      lastTr: props.children.length === index + 1
    }));
  }));
});
exports.Td = utils_2.forwardRef(function Td(props, ref) {
  var density = props.density,
      highlighted = props.highlighted,
      lastChild = props.lastChild,
      index = props.index,
      lastTdChild = props.lastTdChild,
      firstTdChild = props.firstTdChild,
      lastTr = props.lastTr,
      rest = __rest(props, ["density", "highlighted", "lastChild", "index", "lastTdChild", "firstTdChild", "lastTr"]);

  var tbodyTd = core_1.css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\t\t {\n\t\t\tpadding-top: ", "em;\n\t\t\tpadding-bottom: ", "em;\n\t\t\tpadding-left: 2em;\n\t\t\tpadding-right: 2em;\n\t\t\ttext-align: left;\n\t\t\tfont-size: 0.813em;\n\t\t\t", ";\n\t\t\t", ";\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tpadding-top: ", "em;\n\t\t\tpadding-bottom: ", "em;\n\t\t\tpadding-left: 2em;\n\t\t\tpadding-right: 2em;\n\t\t\ttext-align: left;\n\t\t\tfont-size: 0.813em;\n\t\t\t", ";\n\t\t\t", ";\n\t\t}\n\t"])), exports.renderDensity(density), exports.renderDensity(density), !lastChild && "border-bottom: solid 1px " + foundation_1.colors.graphical.bgLightGrey, lastTr && "border-bottom-left-radius: 0.5rem");
  var highlight = core_1.css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\t\t {\n\t\t\theight: ", "em;\n\t\t\twidth: 3px;\n\t\t\tbackground: ", ";\n\t\t\tposition: absolute;\n\t\t\tmargin-left: -2em;\n\t\t\tborder-top-right-radius: 4px;\n\t\t\tborder-bottom-right-radius: 4px;\n\t\t\tmargin-top: calc(", "em + 0.2em);\n\t\t}\n\t"], ["\n\t\t {\n\t\t\theight: ", "em;\n\t\t\twidth: 3px;\n\t\t\tbackground: ", ";\n\t\t\tposition: absolute;\n\t\t\tmargin-left: -2em;\n\t\t\tborder-top-right-radius: 4px;\n\t\t\tborder-bottom-right-radius: 4px;\n\t\t\tmargin-top: calc(", "em + 0.2em);\n\t\t}\n\t"])), exports.renderDensityhighlight(density).height, foundation_1.colors.primary.green, exports.renderDensityhighlight(density).margin);
  return (0, _core.jsx)(lseds_1.lseds.td, _extends({
    css: tbodyTd
  }, rest), highlighted && (0, _core.jsx)(lseds_1.lseds.span, {
    css: highlight
  }), props.children);
});
exports.Table = utils_2.forwardRef(function Table(props, ref) {
  var density = props.density,
      sortable = props.sortable;
  var root = core_1.css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tborder-spacing: 0;\n\t\t\tborder-radius: 8px;\n\t\t\tborder: solid 1px ", ";\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tborder-spacing: 0;\n\t\t\tborder-radius: 8px;\n\t\t\tborder: solid 1px ", ";\n\t\t}\n\t"])), foundation_1.colors.graphical.bgLightGrey);

  var _a = React.useReducer(function (state, action) {
    return action;
  }, {
    index: -1,
    sort: ''
  }),
      sort = _a[0],
      dispatch = _a[1];

  var newContext = React.createContext({
    index: -1,
    sort: ''
  });
  var Provider = newContext.Provider,
      Consumer = newContext.Consumer;
  return (0, _core.jsx)(Provider, {
    value: newContext
  }, (0, _core.jsx)(lseds_1.lseds.table, {
    ref: ref,
    css: root
  }, React.Children.map(props.children, function (child) {
    return React.cloneElement(child, {
      density: density,
      sortable: sortable,
      sort: sort,
      dispatch: dispatch
    });
  })));
});

if (utils_1.isDev) {
  exports.Table.displayName = 'Table';
}

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;